import { Injectable } from '@angular/core';


@Injectable({
  providedIn: "root"
})
export class UtilsService {
  constructor() {  }

  public getDomainOfDomains(domain: string, results: models.DomainVM[]): models.DomainVM {
    const domainToReturn = results.find(el => el.domainCode === domain);
    return domainToReturn;
  }

}
